import script from "./CustomizerMiniTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomizerMiniTab.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__